import { render, staticRenderFns } from "./detailSticker.vue?vue&type=template&id=1ff8c489&scoped=true"
import script from "./detailSticker.vue?vue&type=script&lang=js"
export * from "./detailSticker.vue?vue&type=script&lang=js"
import style0 from "./detailSticker.vue?vue&type=style&index=0&id=1ff8c489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8c489",
  null
  
)

export default component.exports